import { Navigate, useLocation } from "react-router-dom";
import { JSX, useEffect, useState } from "react";
import { useUserContext } from "../contexts/userContext";
import LoadingSpinner from "../components/ui/LoadingSpinner";

interface ProtectedRouteProps {
  children: JSX.Element;
  requiredRole?: "Customer" | "Company"; // Ajoutez tous les rôles nécessaires
}

const ProtectedRoute = ({ children, requiredRole }: ProtectedRouteProps) => {
  const location = useLocation();
  const { isLoading, isAuthenticated, typeRole, checkAuthAndLoadData } = useUserContext();
  const [hasCheckedAuth, setHasCheckedAuth] = useState(false);

  // Vérifier l'authentification seulement si pas encore authentifié et pas encore vérifié
  useEffect(() => {
    if (!isAuthenticated && !hasCheckedAuth && !isLoading) {
      setHasCheckedAuth(true);
      checkAuthAndLoadData();
    }
  }, [isAuthenticated, hasCheckedAuth, isLoading, checkAuthAndLoadData]);

  // Si on est en train de charger, afficher le spinner
  if (isLoading) {
    return <LoadingSpinner size="large" text="Vérification de l'authentification..." />;
  }

  // Si pas authentifié, rediriger vers la page de login
  if (!isAuthenticated) {
    // Redirige vers la page de login avec l'emplacement actuel pour pouvoir y retourner après connexion
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Si un rôle spécifique est requis et que l'utilisateur n'a pas ce rôle
  if (requiredRole && typeRole !== requiredRole) {
    // Redirige vers la page d'erreur ou une page "non autorisé"
    return <Navigate to="/error" state={{ error: "unauthorized" }} replace />;
  }

  // Si tout est OK, afficher le contenu protégé
  return children;
};

export default ProtectedRoute;